import { render, staticRenderFns } from "./ClienteArticulo.vue?vue&type=template&id=bd4fb596&"
import script from "./ClienteArticulo.vue?vue&type=script&lang=js&"
export * from "./ClienteArticulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports